import { z } from "zod";
import { ClientProfileSchema } from "./common";

// ==================
// Profile Response Schema
// ==================

/** Response schema for get/update profile */
export const ClientProfileResponseSchema = ClientProfileSchema;

export type ClientProfileResponse = z.infer<typeof ClientProfileResponseSchema>;

// ==================
// Email Change Request Response
// ==================

/** Response schema for email change request */
export const EmailChangeRequestResponseSchema = z.object({
    new_email: z.email(),
    expires_at: z.string(),
});

export type EmailChangeRequestResponse = z.infer<typeof EmailChangeRequestResponseSchema>;

// ==================
// Verify Email Change Response
// ==================

/** Response schema for email change verification */
export const VerifyEmailChangeResponseSchema = z.object({
    email: z.email(),
});

export type VerifyEmailChangeResponse = z.infer<typeof VerifyEmailChangeResponseSchema>;

